import { Injectable } from '@angular/core';
import {MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition} from "@angular/material/snack-bar";
import {CustomFlagComponent} from "../custom-flag/custom-flag.component";
import {FlagType} from "../utils/enums";



@Injectable({
  providedIn: 'root'
})
export class FlagService {

  constructor(private _snackBar: MatSnackBar) {}

  displayFlag(message: string, type: FlagType, duration?: number,
              horizontalPosition: MatSnackBarHorizontalPosition = 'center',
              verticalPosition: MatSnackBarVerticalPosition = 'top') {
    this._snackBar.openFromComponent(CustomFlagComponent, {
      duration: duration ? duration * 1000 : 5000,
      data: {message, type},
      panelClass: 'custom-flag',
       horizontalPosition,
       verticalPosition,
    });
  }
}
